import _slicedToArray from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Particle_engine;
import { calcExactPositionOrRandomFromSize, clamp, getDistance, getParticleBaseVelocity, getParticleDirectionAngle, getRangeMax, getRangeMin, getRangeValue, getValue, randomInRange, setRangeValue } from "../Utils/NumberUtils";
import { colorToRgb, getHslFromAnimation } from "../Utils/ColorUtils";
import { deepExtend, isInArray, itemFromArray } from "../Utils/Utils";
import { ParticlesOptions } from "../Options/Classes/Particles/ParticlesOptions";
import { Shape } from "../Options/Classes/Particles/Shape/Shape";
import { Vector } from "./Utils/Vector";
import { Vector3d } from "./Utils/Vector3d";
import { alterHsl } from "../Utils/CanvasUtils";
var fixOutMode = function fixOutMode(data) {
  if (!(isInArray(data.outMode, data.checkModes) || isInArray(data.outMode, data.checkModes))) {
    return;
  }
  if (data.coord > data.maxCoord - data.radius * 2) {
    data.setCb(-data.radius);
  } else if (data.coord < data.radius * 2) {
    data.setCb(data.radius);
  }
};
export var Particle = /*#__PURE__*/function () {
  function Particle(engine, id, container, position, overrideOptions, group) {
    _classCallCheck(this, Particle);
    var _a, _b, _c, _d, _e, _f, _g;
    this.id = id;
    this.container = container;
    this.group = group;
    _Particle_engine.set(this, void 0);
    __classPrivateFieldSet(this, _Particle_engine, engine, "f");
    this.fill = true;
    this.close = true;
    this.lastPathTime = 0;
    this.destroyed = false;
    this.unbreakable = false;
    this.splitCount = 0;
    this.misplaced = false;
    this.retina = {
      maxDistance: {}
    };
    this.ignoresResizeRatio = true;
    var pxRatio = container.retina.pixelRatio,
      mainOptions = container.actualOptions,
      particlesOptions = new ParticlesOptions();
    particlesOptions.load(mainOptions.particles);
    var shapeType = particlesOptions.shape.type,
      reduceDuplicates = particlesOptions.reduceDuplicates;
    this.shape = shapeType instanceof Array ? itemFromArray(shapeType, this.id, reduceDuplicates) : shapeType;
    if (overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.shape) {
      if (overrideOptions.shape.type) {
        var overrideShapeType = overrideOptions.shape.type;
        this.shape = overrideShapeType instanceof Array ? itemFromArray(overrideShapeType, this.id, reduceDuplicates) : overrideShapeType;
      }
      var shapeOptions = new Shape();
      shapeOptions.load(overrideOptions.shape);
      if (this.shape) {
        this.shapeData = this.loadShapeData(shapeOptions, reduceDuplicates);
      }
    } else {
      this.shapeData = this.loadShapeData(particlesOptions.shape, reduceDuplicates);
    }
    if (overrideOptions !== undefined) {
      particlesOptions.load(overrideOptions);
    }
    if (((_a = this.shapeData) === null || _a === void 0 ? void 0 : _a.particles) !== undefined) {
      particlesOptions.load((_b = this.shapeData) === null || _b === void 0 ? void 0 : _b.particles);
    }
    this.fill = (_d = (_c = this.shapeData) === null || _c === void 0 ? void 0 : _c.fill) !== null && _d !== void 0 ? _d : this.fill;
    this.close = (_f = (_e = this.shapeData) === null || _e === void 0 ? void 0 : _e.close) !== null && _f !== void 0 ? _f : this.close;
    this.options = particlesOptions;
    this.pathDelay = getValue(this.options.move.path.delay) * 1000;
    var zIndexValue = getRangeValue(this.options.zIndex.value);
    container.retina.initParticle(this);
    var sizeOptions = this.options.size,
      sizeRange = sizeOptions.value;
    this.size = {
      enable: sizeOptions.animation.enable,
      value: getValue(sizeOptions) * container.retina.pixelRatio,
      max: getRangeMax(sizeRange) * pxRatio,
      min: getRangeMin(sizeRange) * pxRatio,
      loops: 0,
      maxLoops: getRangeValue(sizeOptions.animation.count)
    };
    var sizeAnimation = sizeOptions.animation;
    if (sizeAnimation.enable) {
      this.size.status = 0;
      switch (sizeAnimation.startValue) {
        case "min":
          this.size.value = this.size.min;
          this.size.status = 0;
          break;
        case "random":
          this.size.value = randomInRange(this.size) * pxRatio;
          this.size.status = Math.random() >= 0.5 ? 0 : 1;
          break;
        case "max":
        default:
          this.size.value = this.size.max;
          this.size.status = 1;
          break;
      }
      this.size.velocity = ((_g = this.retina.sizeAnimationSpeed) !== null && _g !== void 0 ? _g : container.retina.sizeAnimationSpeed) / 100 * container.retina.reduceFactor;
      if (!sizeAnimation.sync) {
        this.size.velocity *= Math.random();
      }
    }
    this.direction = getParticleDirectionAngle(this.options.move.direction);
    this.bubble = {
      inRange: false
    };
    this.initialVelocity = this.calculateVelocity();
    this.velocity = this.initialVelocity.copy();
    this.moveDecay = 1 - getRangeValue(this.options.move.decay);
    var gravityOptions = this.options.move.gravity;
    this.gravity = {
      enable: gravityOptions.enable,
      acceleration: getRangeValue(gravityOptions.acceleration),
      inverse: gravityOptions.inverse
    };
    this.position = this.calcPosition(container, position, clamp(zIndexValue, 0, container.zLayers));
    this.initialPosition = this.position.copy();
    this.offset = Vector.origin;
    var particles = container.particles;
    particles.needsSort = particles.needsSort || particles.lastZIndex < this.position.z;
    particles.lastZIndex = this.position.z;
    this.zIndexFactor = this.position.z / container.zLayers;
    this.sides = 24;
    var drawer = container.drawers.get(this.shape);
    if (!drawer) {
      drawer = __classPrivateFieldGet(this, _Particle_engine, "f").plugins.getShapeDrawer(this.shape);
      if (drawer) {
        container.drawers.set(this.shape, drawer);
      }
    }
    if (drawer === null || drawer === void 0 ? void 0 : drawer.loadShape) {
      drawer === null || drawer === void 0 ? void 0 : drawer.loadShape(this);
    }
    var sideCountFunc = drawer === null || drawer === void 0 ? void 0 : drawer.getSidesCount;
    if (sideCountFunc) {
      this.sides = sideCountFunc(this);
    }
    this.life = this.loadLife();
    this.spawning = this.life.delay > 0;
    this.shadowColor = colorToRgb(this.options.shadow.color);
    var _iterator = _createForOfIteratorHelper(container.particles.updaters),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var updater = _step.value;
        if (updater.init) {
          updater.init(this);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (drawer && drawer.particleInit) {
      drawer.particleInit(container, this);
    }
    var _iterator2 = _createForOfIteratorHelper(container.plugins),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _step2$value = _slicedToArray(_step2.value, 2),
          plugin = _step2$value[1];
        if (plugin.particleCreated) {
          plugin.particleCreated(this);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  _createClass(Particle, [{
    key: "isVisible",
    value: function isVisible() {
      return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
  }, {
    key: "isInsideCanvas",
    value: function isInsideCanvas() {
      var radius = this.getRadius(),
        canvasSize = this.container.canvas.size;
      return this.position.x >= -radius && this.position.y >= -radius && this.position.y <= canvasSize.height + radius && this.position.x <= canvasSize.width + radius;
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;
      var _iterator3 = _createForOfIteratorHelper(container.plugins),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
            plugin = _step3$value[1];
          container.canvas.drawParticlePlugin(plugin, this, delta);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      container.canvas.drawParticle(this, delta);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.position.x + this.offset.x,
        y: this.position.y + this.offset.y,
        z: this.position.z
      };
    }
  }, {
    key: "getRadius",
    value: function getRadius() {
      var _a;
      return (_a = this.bubble.radius) !== null && _a !== void 0 ? _a : this.size.value;
    }
  }, {
    key: "getMass",
    value: function getMass() {
      return Math.pow(this.getRadius(), 2) * Math.PI / 2;
    }
  }, {
    key: "getFillColor",
    value: function getFillColor() {
      var _a, _b;
      var color = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : getHslFromAnimation(this.color);
      if (color && this.roll && (this.backColor || this.roll.alter)) {
        var backFactor = this.options.roll.mode === "both" ? 2 : 1,
          backSum = this.options.roll.mode === "horizontal" ? Math.PI / 2 : 0,
          rolled = Math.floor((((_b = this.roll.angle) !== null && _b !== void 0 ? _b : 0) + backSum) / (Math.PI / backFactor)) % 2;
        if (rolled) {
          if (this.backColor) {
            return this.backColor;
          }
          if (this.roll.alter) {
            return alterHsl(color, this.roll.alter.type, this.roll.alter.value);
          }
        }
      }
      return color;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor() {
      var _a, _b;
      return (_b = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : getHslFromAnimation(this.strokeColor)) !== null && _b !== void 0 ? _b : this.getFillColor();
    }
  }, {
    key: "destroy",
    value: function destroy(override) {
      this.destroyed = true;
      this.bubble.inRange = false;
      if (this.unbreakable) {
        return;
      }
      this.destroyed = true;
      this.bubble.inRange = false;
      var _iterator4 = _createForOfIteratorHelper(this.container.plugins),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
            plugin = _step4$value[1];
          if (plugin.particleDestroyed) {
            plugin.particleDestroyed(this, override);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      if (override) {
        return;
      }
      var destroyOptions = this.options.destroy;
      if (destroyOptions.mode === "split") {
        this.split();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.opacity) {
        this.opacity.loops = 0;
      }
      this.size.loops = 0;
    }
  }, {
    key: "split",
    value: function split() {
      var splitOptions = this.options.destroy.split;
      if (splitOptions.count >= 0 && this.splitCount++ > splitOptions.count) {
        return;
      }
      var rate = getRangeValue(splitOptions.rate.value);
      for (var i = 0; i < rate; i++) {
        this.container.particles.addSplitParticle(this);
      }
    }
  }, {
    key: "calcPosition",
    value: function calcPosition(container, position, zIndex) {
      var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var _a, _b, _c, _d;
      var _iterator5 = _createForOfIteratorHelper(container.plugins),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
            plugin = _step5$value[1];
          var pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;
          if (pluginPos !== undefined) {
            return Vector3d.create(pluginPos.x, pluginPos.y, zIndex);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var canvasSize = container.canvas.size,
        exactPosition = calcExactPositionOrRandomFromSize({
          size: canvasSize,
          position: position
        }),
        pos = Vector3d.create(exactPosition.x, exactPosition.y, zIndex),
        radius = this.getRadius(),
        outModes = this.options.move.outModes,
        fixHorizontal = function fixHorizontal(outMode) {
          fixOutMode({
            outMode: outMode,
            checkModes: ["bounce", "bounce-horizontal"],
            coord: pos.x,
            maxCoord: container.canvas.size.width,
            setCb: function setCb(value) {
              return pos.x += value;
            },
            radius: radius
          });
        },
        fixVertical = function fixVertical(outMode) {
          fixOutMode({
            outMode: outMode,
            checkModes: ["bounce", "bounce-vertical"],
            coord: pos.y,
            maxCoord: container.canvas.size.height,
            setCb: function setCb(value) {
              return pos.y += value;
            },
            radius: radius
          });
        };
      fixHorizontal((_a = outModes.left) !== null && _a !== void 0 ? _a : outModes.default);
      fixHorizontal((_b = outModes.right) !== null && _b !== void 0 ? _b : outModes.default);
      fixVertical((_c = outModes.top) !== null && _c !== void 0 ? _c : outModes.default);
      fixVertical((_d = outModes.bottom) !== null && _d !== void 0 ? _d : outModes.default);
      if (this.checkOverlap(pos, tryCount)) {
        return this.calcPosition(container, undefined, zIndex, tryCount + 1);
      }
      return pos;
    }
  }, {
    key: "checkOverlap",
    value: function checkOverlap(pos) {
      var tryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var collisionsOptions = this.options.collisions,
        radius = this.getRadius();
      if (!collisionsOptions.enable) {
        return false;
      }
      var overlapOptions = collisionsOptions.overlap;
      if (overlapOptions.enable) {
        return false;
      }
      var retries = overlapOptions.retries;
      if (retries >= 0 && tryCount > retries) {
        throw new Error("Particle is overlapping and can't be placed");
      }
      var overlaps = false;
      var _iterator6 = _createForOfIteratorHelper(this.container.particles.array),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var particle = _step6.value;
          if (getDistance(pos, particle.position) < radius + particle.getRadius()) {
            overlaps = true;
            break;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      return overlaps;
    }
  }, {
    key: "calculateVelocity",
    value: function calculateVelocity() {
      var baseVelocity = getParticleBaseVelocity(this.direction),
        res = baseVelocity.copy(),
        moveOptions = this.options.move,
        rad = Math.PI / 180 * getRangeValue(moveOptions.angle.value),
        radOffset = Math.PI / 180 * getRangeValue(moveOptions.angle.offset),
        range = {
          left: radOffset - rad / 2,
          right: radOffset + rad / 2
        };
      if (!moveOptions.straight) {
        res.angle += randomInRange(setRangeValue(range.left, range.right));
      }
      if (moveOptions.random && typeof moveOptions.speed === "number") {
        res.length *= Math.random();
      }
      return res;
    }
  }, {
    key: "loadShapeData",
    value: function loadShapeData(shapeOptions, reduceDuplicates) {
      var shapeData = shapeOptions.options[this.shape];
      if (shapeData) {
        return deepExtend({}, shapeData instanceof Array ? itemFromArray(shapeData, this.id, reduceDuplicates) : shapeData);
      }
    }
  }, {
    key: "loadLife",
    value: function loadLife() {
      var container = this.container,
        particlesOptions = this.options,
        lifeOptions = particlesOptions.life,
        life = {
          delay: container.retina.reduceFactor ? getRangeValue(lifeOptions.delay.value) * (lifeOptions.delay.sync ? 1 : Math.random()) / container.retina.reduceFactor * 1000 : 0,
          delayTime: 0,
          duration: container.retina.reduceFactor ? getRangeValue(lifeOptions.duration.value) * (lifeOptions.duration.sync ? 1 : Math.random()) / container.retina.reduceFactor * 1000 : 0,
          time: 0,
          count: particlesOptions.life.count
        };
      if (life.duration <= 0) {
        life.duration = -1;
      }
      if (life.count <= 0) {
        life.count = -1;
      }
      return life;
    }
  }]);
  return Particle;
}();
_Particle_engine = new WeakMap();